import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useHistorySearchPatientStore = defineStore('istorySearchPatient', () => {
  const history = ref([]);
  async function setHistoryData(dataUpdate: any) {
    history.value = dataUpdate;
  }

  return {
    history,
    setHistoryData,
  }
})
